// Upload-form choices and how they map to the peer groups in benchmarks.json.
// The industry values are sent to the backend, which looks up its sector context
// by exact name (cloud-function helpers/sectorContext.json), so they must not change.
export const BENCHMARKS = {
  industries: [
    "Industrials",
    "Consumer Discretion",
    "Financials",
    "Consumer Staples",
    "Basic Materials",
    "Technology",
    "Energy",
    "Health Care",
    "Utilities",
    "Real Estate",
    "Telecommunications",
    "Higher Education"
  ],
  indices: [
    "FTSE 100",
    "FTSE 250",
    "FTSE 350"
  ],
};

// Energy + Utilities and Technology + Telecommunications are compared as one group
export const INDUSTRY_GROUP = {
  "Industrials": "industrials",
  "Consumer Discretion": "consumer_discretionary",
  "Financials": "financials",
  "Consumer Staples": "consumer_staples",
  "Basic Materials": "basic_materials",
  "Technology": "technology_telecoms",
  "Energy": "energy_utilities",
  "Health Care": "health_care",
  "Utilities": "energy_utilities",
  "Real Estate": "real_estate",
  "Telecommunications": "technology_telecoms",
  "Higher Education": "higher_education",
};

export const INDEX_GROUP = {
  "FTSE 100": "ftse_100",
  "FTSE 250": "ftse_250",
  "FTSE 350": "ftse_350",
};

// Dropdown text where it differs from the value sent to the backend
const INDUSTRY_OPTION_LABELS = {
  "Consumer Discretion": "Consumer Discretionary",
};

export const industryOptionLabel = (value) => INDUSTRY_OPTION_LABELS[value] ?? value;

export default BENCHMARKS;
